import {InfoBlockDTO} from 'kashable-mobile-common';

import {getObject, putObject, remove} from './StorageUtil';

const READ_CARD_KEY = 'infoBlocks';

export type BlockStatus = 'reading' | 'read' | 'pristine';

export type BlockStatusDictionary = {
    [K in InfoBlockDTO.TypeEnum]?: BlockStatus;
};

const areAllRead = (blocksToCheck: Array<InfoBlockDTO.TypeEnum>) => {
    const savedBlocks = getObject<BlockStatusDictionary>(READ_CARD_KEY, {});
    const notRead = blocksToCheck.filter((bl) => !(bl in savedBlocks) || savedBlocks[bl] !== 'read');
    return !notRead.length;
};

const saveProgress = (dictionairy: BlockStatusDictionary) => {
    putObject(READ_CARD_KEY, dictionairy);
};

const clearProgress = () => {
    remove(READ_CARD_KEY);
};

const initializeCardStates = (length: number) => {
    if (length === 0) {
        return [];
    }
    const arr: BlockStatus[] = Array(length).map(() => 'pristine');
    arr[0] = 'reading';
    return arr;
};

export {areAllRead, saveProgress, clearProgress, initializeCardStates};
